export default __webpack_public_path__ + "static/media/saguadin.d50b3eb4.png";